import { Home, User, Briefcase, Wallet, Landmark } from "lucide-react";

// Uniform primary navigation tab set — shared by the desktop header pills and the mobile bottom bar.
export const NAV_TABS = [
  {
    key: "briefing", label: "Briefing", short: "Briefing", Icon: Home,
    active: "bg-[#1A1A18] text-white",
    idle: "bg-white text-[var(--text-2)] border border-[var(--line)] hover:border-[#1A1A18] hover:text-[#1A1A18]",
    mActive: "text-slate-100", mBg: "bg-[#1A1A18] text-white",
  },
  {
    key: "personal", label: "Personal", short: "Personal", Icon: User,
    active: "bg-blue-600 text-white",
    idle: "bg-white text-blue-700 border border-blue-300 hover:border-blue-500",
    mActive: "text-blue-400", mBg: "bg-blue-600 text-white",
  },
  {
    key: "business", label: "Business", short: "Business", Icon: Briefcase,
    active: "bg-amber-500 text-white",
    idle: "bg-white text-amber-700 border border-amber-300 hover:border-amber-500",
    mActive: "text-amber-400", mBg: "bg-amber-500 text-white",
  },
  {
    key: "snapbudget", label: "SnapBudget", short: "SnapBudget", Icon: Wallet,
    active: "bg-emerald-600 text-white",
    idle: "bg-white text-emerald-700 border border-emerald-300 hover:border-emerald-500",
    mActive: "text-emerald-400", mBg: "bg-emerald-600 text-white",
  },
  {
    key: "tax", label: "Tax Clarity Hub", short: "Tax Hub", Icon: Landmark,
    active: "bg-orange-600 text-white",
    idle: "bg-white text-orange-700 border border-orange-300 hover:border-orange-500",
    mActive: "text-orange-400", mBg: "bg-orange-600 text-white",
  },
];
